export default __webpack_public_path__ + "images/hr-faded-bottom.png";